import { format } from 'date-fns';

export default function BusinessDaysCalendar(numberOfValidDays = 10) {
  const labelFormat = 'd';
  const longLabelFormat = 'EEEE, MMMM d';
  const valueFormat = 'MM-dd-yyyy';

  const preDates = [];
  const dates = [];
  const postDates = [];
  const dayOfWeek = (new Date()).getDay();

  // Pre-populate invalid days of the week from Monday until today
  if (dayOfWeek > 1 && dayOfWeek !== 6) {
    const elapsedWeekdays = dayOfWeek - 1;
    const preDatePointer = getMondayOfWeek(new Date());
    while (preDates.length < elapsedWeekdays) {
      const date = {
        label: format(preDatePointer, labelFormat),
        longLabel: format(preDatePointer, longLabelFormat),
        value: format(preDatePointer, valueFormat),
        isValid: false
      };
      preDates.push(date);
      preDatePointer.setDate(preDatePointer.getDate() + 1);
    }
  }

  // Populate the next weekdays
  const datePointer = new Date();
  while (dates.length < numberOfValidDays) {
    if (![0, 6].includes(datePointer.getDay())) {
      const date = {
        label: format(datePointer, labelFormat),
        longLabel: format(datePointer, longLabelFormat),
        value: format(datePointer, valueFormat),
        isValid: true
      };
      dates.push(date);
    }
    datePointer.setDate(datePointer.getDate() + 1);
  }

  // Populate until Friday as invalid dates
  const postDatePointer = new Date(datePointer);
  while (postDatePointer.getDay() !== 6 && postDatePointer.getDay() !== 0)  {
    const date = {
      label: format(postDatePointer, labelFormat),
      longLabel: format(postDatePointer, longLabelFormat),
      value: format(postDatePointer, valueFormat),
      isValid: false
    };
    postDates.push(date);
    postDatePointer.setDate(postDatePointer.getDate() + 1);
  }

  return [ ...preDates, ...dates, ...postDates ];
}

function getMondayOfWeek(date) {
  const actualDayOfWeek = date.getDay();
  const d = new Date(date);

  if (actualDayOfWeek === 0) {
    return new Date(d.setDate(d.getDate() + 1));
  } else if (actualDayOfWeek === 1) {
    return new Date(d);
  } else {
    // Monday is int day of week minus 1 (i.e. Wed is 3-1 = 2 days before)
    const diffFromMonday = actualDayOfWeek - 1;
    return new Date(d.setDate(d.getDate() - diffFromMonday));
  }
}


